import { AlertOutlineIcon } from '@atgfr8/icons';
export const EldCaution = () => {
  return (
    <div class="w-full rounded-lg px-2 py-1 border-solid border-caution-yellow border-2 bg-caution-yellow font-roboto text-sm">
      <div class="flex items-center gap-x-2">
        <AlertOutlineIcon class="text-caution-yellow!" />
        <div class="flex flex-col w-full">
          No ELD-enabled asset was found in Trucker Tools using these truck and
          trailer numbers. To proceed with ELD tracking, update these numbers or
          have the carrier register the asset(s) with Trucker Tools. If these
          are not updated, load will be tracked using entered mobile number.
        </div>
      </div>
    </div>
  );
};
